<template>
  <div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="auto" class="demo-ruleForm">

      <el-form-item prop="telephone">
        <el-input v-model="ruleForm.telephone" clearable placeholder="请输入手机号">
          <i slot="prefix" class="el-input__icon el-icon-phone-outline">
          </i>
        </el-input>
      </el-form-item>

      <el-form-item prop="message">
        <el-input :maxlength='6' v-model="ruleForm.code" placeholder="请输入短信验证码">
          <i slot="prefix" class="el-input__icon el-icon-message">
          </i>
        </el-input>
        <el-link :underline="false" type="success" v-if="codeState == 1" @click="getSMSCode(1)">发送验证码</el-link>
        <el-link :underline="false" type="success" v-if="codeState == 2" @click="getSMSCode(2)">{{second}}s后重新发送
        </el-link>
      </el-form-item>

      <el-form-item class="form_item_btn">
        <el-button class="btn_submit" type="success" @click="submitForm()">下一步</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import { sendSms, unmatched } from "@/network/loginRequest/api";
import utils from "@/util/index";

export default {
  data() {
    return {
      ruleForm: {
        telephone: "",
        code: ""
      },
      second: 60,
      codeState: 1, // 1--未发送，2--已发送
      checked: false
    };
  },
  methods: {
    submitForm() {
      let form = this.ruleForm;
      let RegPhone = new RegExp(
        /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      ); //验证手机号
      if (form.telephone == "") {
        utils.tips("warning", "账号不能为空");
      } else if (!RegPhone.test(form.telephone)) {
        utils.tips("warning", "请输入正确的手机号码");
      } else if (!(form.telephone == this.$store.state.user.telephone)) {
        utils.tips("warning", "请输入当前账号的手机号码");
      } else if (form.code == "") {
        utils.tips("warning", "请输入验证码");
      } else {
        //验证验证码是否和手机符合
        let fd = new FormData();
        fd.append("phone", form.telephone);
        fd.append("telephone", form.telephone);
        fd.append("code", form.code);

        unmatched(fd).then(res => {
          if (!res.data) {
            //匹配时成功返回false
            this.$bus.resetFrom = form;
            this.$emit("update:isShow", false);
          } else {
            utils.tips("error", "请确保验证码输入正确");
          }
        });
      }
    },

    getSMSCode(type) {
      let RegPhone = new RegExp(
        /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      ); //验证手机号

      var tel = this.ruleForm.telephone;
      var code = this.ruleForm.code;

      if (tel == "") {
        utils.tips("warning", "请输入手机号码");
        return false;
      }
      if (!RegPhone.test(tel)) {
        utils.tips("warning", "请输入正确的手机号码");
        return false;
      }

      if (!(tel == this.$store.state.user.telephone)) {
        utils.tips("warning", "请输入当前账号的手机号码");
        return false;
      }

      if (type == 1) {
        sendSms(tel)
          .then(res => {
            console.log(res);
            if (res.data.state == "1") {
              utils.tips("success", "发送成功！");
              this.codeState = 2;
              let that = this;
              let t = setInterval(() => {
                if (this.second == 0) {
                  that.second = 60;
                  clearInterval(t);
                  this.codeState = 1;
                } else {
                  that.second = that.second - 1;
                }
              }, 1000);
            } else {
              utils.tips("info", res.data.code);
            }
          })
          .catch(err => {
            utils.tips("error", err);
          });
      }
    }
  }
};
</script>

<style lang='less' scoped>
.el-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .form_item_btn {
    margin-top: 10px;
  }

  .el-form-item:nth-child(3) {
    margin-top: 70px;
    margin-bottom: 20px;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 30px;

    .el-form-item__content {
      position: relative;

      .el-link {
        position: absolute;
        top: 0;
        right: 5px;
      }
    }

    .btn_submit {
      width: 100%;
      color: #5b9974;
      background-color: #fff;
      border-color: #24ba58;

      &:hover {
        background-color: #24ba58;
        color: #fff;
      }
    }

    .el-button--success:active {
      background-color: skyblue;
      border-color: skyblue;
    }

    /deep/.el-input__inner:focus {
      border-color: #24ba58;
    }
  }
}

//UI样式修改
.pass_state {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;

  .pass_state_rt > a:nth-child(2) {
    margin-left: 20px;
  }

  .pass_state_rt > a {
    color: #24ba58;
  }

  /deep/.el-checkbox__inner {
    border: 1px solid #878787;
  }

  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #24ba58;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #24ba58;
    border-color: #24ba58;
  }
}
</style>